import * as React from 'react';
import { CommandBarButton } from '@fluentui/react/lib/Button';
import { ControlIcons } from 'owa-control-icons';
import { AppDrawer } from 'owa-app-drawer';
import { observer } from 'mobx-react-lite';
import loc from 'owa-localize';
import { moreApps } from 'owa-locstrings/lib/strings/moreapps.locstring.json';

import styles from 'owa-left-rail-item/lib/components/LeftRailItem.scss';

export default observer(function AppDrawerButton() {
    const divRef = React.useRef<HTMLDivElement>();
    const [isCalloutVisible, setIsCalloutVisible] = React.useState(false);

    const toggleIsCalloutVisible = React.useCallback(() => {
        setIsCalloutVisible(!isCalloutVisible);
    }, [isCalloutVisible]);

    return (
        <div ref={divRef}>
            <CommandBarButton
                styles={{
                    root: styles.appDrawerButton,
                }}
                menuIconProps={{
                    iconName: ControlIcons.More,
                }}
                onClick={toggleIsCalloutVisible}
                title={loc(moreApps)}
            />
            {isCalloutVisible && <AppDrawer target={divRef} onDismiss={toggleIsCalloutVisible} />}
        </div>
    );
});
